function installProductCardAromaRefresh(pnk) {
  let scheduled = false;

  pnk.refreshProductCardAromas = (root) => {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    const elems = scope.querySelectorAll('.product-card-aroma');
    [...elems].forEach((elem) => {
      const rect = elem.getBoundingClientRect();
      if (0 < rect.top && rect.top < window.innerHeight * 0.8) {
        elem.classList.add('show-aromas');
      } else {
        elem.classList.remove('show-aromas');
      }
    });
  };

  document.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      pnk.refreshProductCardAromas();
    });
  }, { capture: true, passive: true });
}

const pnk = new (PnK())();

pnk.init();

window.pnk = pnk;
installProductCardAromaRefresh(pnk);

function PnK() {
  const dimensions = {
    tablet: 768,
    desktop: 1024,
  };
  const imageType = {
    LARGE: 'large', // full / full (mobile / desktop)
    MEDIUM: 'medium', // full / half (mobile / desktop)
    NORMAL: 'normal', // half / quarter (mobile / desktop)
    SMALL: 'small', // big icon
  };

  return class PnKClass {
    pnkBoost = new PnKBoost({ parent: this });
    pnkQuiz = new PnKQuiz({ parent: this });
    pnkPreferences = new PnKPreferences({ parent: this });

    quizController = this.pnkQuiz.controller;

    init() {
      this.pnkBoost.init();
      this.pnkQuiz.init();
      this.pnkPreferences.init();

      console.log('PnK initialized');
    }

    isQuizDone() {
      return !!this.restore('quiz', 'preferences');
    }

    renderImage({
      parent,
      src = null,
      mobileSrc = null,
      imgClassnames = 'w-full h-auto',
      rootClassnames = 'relative w-full h-full',
      type = imageType.NORMAL,
      lazy = true,
      alt = null,
      priority
    }) {
      if (!parent || (!src && !mobileSrc)) return;

      const sizes = {
        [imageType.LARGE]: {
          x1: [350, 1400],
          x2: [700, 2800],
        },
        [imageType.MEDIUM]: {
          x1: [350, 700],
          x2: [700, 1400],
        },
        [imageType.NORMAL]: {
          x1: [350, 570],
          x2: [700, 1140],
        },
        [imageType.SMALL]: {
          x1: [100, 100],
          x2: [200, 200],
        },
      };

      const optimizeImage = (imgUrl, size) => {
        if (!imgUrl) return '';

        const parts = imgUrl.split('.');
        const ext = parts.pop();

        return `${parts.join('.')}_${size}x.${ext}`;
      };

      const url = {
        desktop: src?.split('?')[0],
        mobile: mobileSrc?.split('?')[0],
      };
      const image = {
        desktop: {
          default: url.desktop || '',
          x1: optimizeImage(url.desktop || url.mobile, sizes[type].x1[1]),
          x2: optimizeImage(url.desktop || url.mobile, sizes[type].x2[1]),
        },
        mobile: {
          default: url.mobile || '',
          x1: optimizeImage(url.mobile || url.desktop, sizes[type].x1[0]),
          x2: optimizeImage(url.mobile || url.desktop, sizes[type].x2[0]),
        },
      };

      const root = document.createElement('figure');
      root.classList.add(...rootClassnames.split(' '));

      const picture = document.createElement('picture');
      root.appendChild(picture);

      const source = document.createElement('source');
      source.srcset = [
        `${image.mobile.x1 ? `${image.mobile.x1} 1x` : ''}`,
        `${image.mobile.x2 ? `${image.mobile.x2} 2x` : ''}`,
      ].join(', ');
      source.media = `(max-width: ${dimensions.tablet - 1}px)`;
      picture.appendChild(source);

      const img = document.createElement('img');
      img.classList.add(...imgClassnames.split(' '));
      img.src = src ? image.desktop.default : image.mobile.default;
      img.srcset = [
        `${image.desktop.x1 ? `${image.desktop.x1} 1x` : ''}`,
        `${image.desktop.x2 ? `${image.desktop.x2} 2x` : ''}`,
      ].join(', ');
      if (alt) img.alt = alt;
      if (lazy) img.loading = 'lazy';
      if (priority) img.fetchPriority = priority;
      picture.appendChild(img);

      parent.appendChild(root);
    }

    getAlpineData(name) {
      const data = getAlpineDataContains(name);

      if (data) return data[name];

      return null;
    }

    setAlpineData(name, value) {
      const data = getAlpineDataContains(name);

      if (data) data[name] = value;
    }

    store(storageName, key, value) {
      const data = JSON.parse(localStorage[storageName] || '{}');

      this.set(data, key, value);
      localStorage[storageName] = JSON.stringify(data);
    }

    restore(storageName, key) {
      const data = JSON.parse(localStorage[storageName] || '{}');
      const result = key ? this.get(data, key) || '' : data;

      return result;
    }

    getJsonDataFrom(nodeSelector) {
      const jsons = [...(document.querySelectorAll(nodeSelector) || [])].map((data) => {
        const json = JSON.parse(data.textContent);

        return json;
      });

      return mergeJsons(...jsons);
    }

    tagToKey(tag) {
      return tag
        .replace(/::/g, '__')
        .replace(/ /g, '_')
        .replace(/&/g, 'and')
        .replace(/'/g, '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    toMoney(number) {
      return window.Shopify?.moneyFormat?.replace('{{ amount_no_decimals }}', Math.round(Number(number)));
    }

    compose(...fns) {
      return (arg) => fns.reduce((g, f) => f(g), arg);
    }

    get(obj, path) {
      return path.split('.').reduce((acc, key) => acc && acc[key], obj);
    }

    set(obj, path, value) {
      path.split('.').reduce((acc, key, id, list) => {
        if (acc && id === list.length - 1)
          acc[key] = value;
        else if (acc && !acc[key])
          acc[key] = {};
        return acc && acc[key];
      }, obj);
    }

    async getRootScopeData(path, after = () => {}) {
      let result = null;
      const start = Date.now();
      const delay = 3000;

      const tick = (resolve) => () => {
        const current = Date.now();

        result = this.get(window, path);

        if (result || current - start > delay) {
          after(result);
          resolve();
          return;
        }

        requestAnimationFrame(tick(resolve));
      };

      return await new Promise((resolve) => requestAnimationFrame(tick(resolve)))
        .then(() => result);
    }
  };

  function getAlpineDataContains(name) {
    const dataProxies = document.querySelector('[x-data="app"]')?._x_dataStack || [];
    const error = (msg) => console.error(`[PNK_ERROR] getAlpineDataContains:`, msg);

    if (!dataProxies.length) {
      error('cannot find [x-data="app"] node or don`t have any alpine data proxies');
      return null;
    }

    for (let i = 0; i < dataProxies.length; i++) {
      if (name in dataProxies[i]) return dataProxies[i];
    }

    error(`cannot find '${name}' property`);
    return null;
  }

  function mergeJsons(...jsons) {
    const isArray = (node) => Array.isArray(node);
    const isObject = (node) => !!node && !Array.isArray(node) && typeof node === 'object';
    const mergeNodes = (first, second) => {
      if (!first) return second;
      else if (!second) return first;
      else if (isArray(first) && isArray(second)) return [...first, ...second];
      else if (isObject(first) && isObject(second)) {
        const keys = [...Object.keys(first), ...Object.keys(second)];
        const obj = keys.reduce(
          (acc, key) => ({
            ...acc,
            [key]: mergeNodes(first[key], second[key]),
          }),
          {}
        );

        return obj;
      } else return second;
    };

    return jsons.reduce(mergeNodes, {});
  }
}
